export default __webpack_public_path__ + "img/9.asset.913ae6d3.jpeg";